import { Col, Container, Row } from "react-bootstrap"
import Header from "../components/Header"
import NewsComponent from "../components/News"
import CarouselHome from "../components/CarouselHome"
//import EventTable from "../components/EventTable"



const PageHome = () => {
    return (
        <div>
            <Header />
            <div className="bg-cover">
            <Row style={{height: "30vh"}}>
                <Col md='8'>
                    <h1 hidden>ω.LAB</h1>
                    <div hidden>
                        “Keep your eyes open for unusual results. Luck is an ingredient in a scientific career but one needs to catch it when it passes by.”
                    </div>
                </Col>
                <Col sm='12' className="d-flex flex-column align-items-end justify-content-end">
                    <div style={{fontSize: '14px'}} className="mb-5">
                        <b><i>Optics and Photonics News 2019: </i></b> Toward a quantum plasmonic immunoassay, December 2019&nbsp;&nbsp;
                        <a style={{color: 'white'}} href="https://www.osa-opn.org/home/articles/volume_30/december_2019/extras/toward_a_quantum_plasmonic_immunoassay/" target="_blank" rel="noopener noreferrer">{"[Link]"}</a>
                    </div>
                </Col>
            </Row>
            </div>
            <br />
            <Container>
                <CarouselHome />
            </Container>
            <Container>
                <br />
                
                <NewsComponent />
            </Container>
            
            {/* <div className="container-fluid" style={{maxWidth : '1200px'}} hidden={true}>
                <EventTable />
            </div> */}
        </div>
    )
}

export default PageHome